module.exports = {"mainArr":[{"text":"首页","name":"conferenceIndex"},{"text":"云会场","name":"cloudMeeting"},{"text":"云上展厅","name":"cloudShow"},{"text":"大会议程","name":"meetingAgenda"},{"text":"大会嘉宾","name":"guests"},{"text":"主论坛","name":"mainForum"},{"text":"技术分论坛","name":"subForum"}]}


//////////////////
// WEBPACK FOOTER
// ./src/gtn/views/frontViews/developerConference/components/headerConfig.json
// module id = 0ndu
// module chunks = 86